import styled from '@emotion/styled';
import SPACING from '@zola/zola-ui/src/styles/emotion/spacing';
import MEDIA_QUERY_V2, { SCREEN_LG } from '@zola/zola-ui/src/styles/emotion/mediaQueryV2';
import FONT from '@zola/zola-ui/src/styles/emotion/fonts';

export const SEOBlocksWrapper = styled.div`
  max-width: ${SCREEN_LG}px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 32px 24px;

  ${MEDIA_QUERY_V2.EXCLUDE_MOBILE} {
    padding: 32px 40px;
  }
`;

export const SEOBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.XS};
`;

export const SEOCopy = styled.div`
  h4 {
    margin-bottom: ${SPACING.XS};
  }

  ul,
  ol,
  p {
    font-size: ${FONT.SIZE.SMALL};
    margin-bottom: ${SPACING.XS};
  }

  ul,
  ol {
    list-style: revert;
    list-style-position: inside;

    // A list inside a list needs a left padding, but no bottom margin.
    ul,
    ol {
      padding-left: 20px;
      margin-bottom: 0;
    }
  }

  li {
    margin-bottom: ${SPACING.XXS};
  }
`;

export const SEOList = styled.p<{ centered?: boolean }>`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: ${SPACING.SM};

  ${MEDIA_QUERY_V2.MOBILE} {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const SEOReviews = styled.div`
  width: 100%;
  display: grid;
  gap: ${SPACING.XS};

  ${MEDIA_QUERY_V2.EXCLUDE_MOBILE} {
    grid-template-columns: repeat(3, 1fr);
    gap: ${SPACING.SM};
  }
`;
